import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/FitLandingPage";
import QuestionPage from "@/pages/FitQuestionPage";
import FitScenarioPage from "@/pages/FitScenarioPage";
import RecommendationPage from "@/pages/FitRecommendationPage";
import ComparePage from "@/pages/FitComparePage";
import SuccessPage from "@/pages/FitSuccessPage";
import AdminCmsPage from "@/pages/AdminCmsPage";
import PrivacyTermsPage from "@/pages/PrivacyTermsPage";
import { AppFooter } from "@/components/AppFooter";

function App() {
  return (
    <div className="rescue-app" data-testid="advisor-app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/how-it-works" element={<Navigate to="/question/workplace" replace />} />
          <Route path="/question/:questionId" element={<QuestionPage />} />
          <Route path="/scenario/:optionId" element={<FitScenarioPage />} />
          <Route path="/recommendation" element={<RecommendationPage />} />
          <Route path="/compare" element={<ComparePage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/scenarios" element={<Navigate to="/question/workplace" replace />} />
          <Route path="/register/:scenarioId" element={<Navigate to="/question/workplace" replace />} />
          <Route path="/diagnose/:sessionId" element={<Navigate to="/question/workplace" replace />} />
          <Route path="/solutions/:sessionId" element={<Navigate to="/recommendation" replace />} />
          <Route path="/claim/:sessionId" element={<Navigate to="/recommendation" replace />} />
          <Route path="/thank-you/:sessionId" element={<Navigate to="/success" replace />} />
          <Route path="/cms" element={<AdminCmsPage />} />
          <Route path="/privacy-terms" element={<PrivacyTermsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <AppFooter />
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;